<div class="media profile-media">
  <img class="b-r-10" [src]= "profileimg ? profileimg : 'https://media.istockphoto.com/id/1393750072/vector/flat-white-icon-man-for-web-design-silhouette-flat-illustration-vector-illustration-stock.jpg?s=612x612&w=0&k=20&c=s9hO4SpyvrDIfELozPpiB_WtzQV9KhoMUP9R9gVohoU='" alt="" width="28px">
  <div class="media-body"><span>{{userData?.name}}</span>
    
    <p class="mb-0 font-roboto">{{ getUserGroupName() }} <i class="middle fa fa-angle-down"></i></p>
  </div>
  
</div>
<ul class="profile-dropdown onhover-show-div">
  <li routerLink="/new-profile/{{userDetails?.userID}}"><a><app-feather-icons [icon]="'user'"></app-feather-icons><span>Account </span></a></li>
  <!-- <li><a href="email"><app-feather-icons [icon]="'mail'"></app-feather-icons><span>Inbox</span></a></li> -->
      
  <li><a href="#"><app-feather-icons [icon]="'settings'"></app-feather-icons><span>Settings</span></a></li>
  <li (click)="openChangePasswordModal()"><a><app-feather-icons [icon]="'lock'"></app-feather-icons><span>Change Password</span></a></li>
  <li (click)="logoutFunc()"><app-feather-icons [icon]="'log-in'"></app-feather-icons><span>Log out</span></li>
</ul>

<!-- Change Password Modal Template -->
<ng-template #changePasswordModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title"><i class="fa fa-lock me-2"></i>Change Password</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="text-warning mb-4">
      <i class="fa fa-info-circle me-2"></i>
      <span>For security reasons, your new password must be at least 8 characters long and should include a mix of letters, numbers, and special characters.</span>
    </div>

    <form [formGroup]="changePasswordForm">
      <!-- Current Password -->
      <div class="mb-3">
        <label for="oldPassword" class="form-label">Current Password <span class="text-danger">*</span></label>
        <div class="input-group">
          <span class="input-group-text"><i class="fa fa-key"></i></span>
          <input
            [type]="showOldPassword ? 'text' : 'password'"
            id="oldPassword"
            class="form-control"
            formControlName="oldPassword"
            placeholder="Enter your current password"
          />
          <button type="button" class="btn input-group-text" (click)="togglePasswordVisibility('old')">
            <i class="fa" [ngClass]="showOldPassword ? 'fa-eye-slash text-muted' : 'fa-eye'"></i>
          </button>
        </div>
        <div *ngIf="changePasswordForm.get('oldPassword')?.invalid && changePasswordForm.get('oldPassword')?.touched" class="text-danger mt-1">
          <small><i class="fa fa-exclamation-circle me-1"></i>Current password is required</small>
        </div>
      </div>
    
      <!-- New Password -->
      <div class="mb-3">
        <label for="newPassword" class="form-label">New Password <span class="text-danger">*</span></label>
        <div class="input-group">
          <span class="input-group-text"><i class="fa fa-lock"></i></span>
          <input
            [type]="showNewPassword ? 'text' : 'password'"
            id="newPassword"
            class="form-control"
            formControlName="newPassword"
            placeholder="Enter your new password"
          />
          <button type="button" class="btn input-group-text text-muted" (click)="togglePasswordVisibility('new')">
            <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
          </button>
        </div>
        <div *ngIf="changePasswordForm.get('newPassword')?.invalid && changePasswordForm.get('newPassword')?.touched" class="text-danger mt-1">
          <small><i class="fa fa-exclamation-circle me-1"></i>New password is required and must be at least 8 characters</small>
        </div>
      </div>
    
      <!-- Confirm Password -->
      <div class="mb-3">
        <label for="confirmPassword" class="form-label">Confirm Password <span class="text-danger">*</span></label>
        <div class="input-group">
          <span class="input-group-text"><i class="fa fa-check-circle"></i></span>
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            id="confirmPassword"
            class="form-control"
            formControlName="confirmPassword"
            placeholder="Confirm your new password"
          />
          <button type="button" class="btn input-group-text text-muted" (click)="togglePasswordVisibility('confirm')">
            <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
          </button>
        </div>
        <div *ngIf="changePasswordForm.get('confirmPassword')?.invalid && changePasswordForm.get('confirmPassword')?.touched" class="text-danger mt-1">
          <small><i class="fa fa-exclamation-circle me-1"></i>Confirm password is required</small>
        </div>
        <div *ngIf="changePasswordForm.hasError('passwordMismatch') && changePasswordForm.get('confirmPassword')?.touched" class="text-danger mt-1">
          <small><i class="fa fa-exclamation-triangle me-1"></i>Passwords do not match</small>
        </div>
      </div>

      <!-- Password Guidelines section - uncomment if needed -->
      <!-- <div class="password-guidelines mt-4 mb-3 p-3 bg-light rounded">
        <h6 class="mb-2"><i class="fa fa-shield-alt me-2"></i>Password Guidelines:</h6>
        <ul>
          <li>At least 8 characters</li>
          <li>At least one uppercase letter</li>
          <li>At least one lowercase letter</li>
          <li>At least one number</li>
          <li>At least one special character</li>
        </ul>
      </div> -->
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('Cancel')">
      <i class="fa fa-times me-1"></i>Cancel
    </button>
    <button type="button" class="btn btn-primary" [disabled]="changePasswordForm.invalid" (click)="changePassword()">
      <i class="fa fa-check-circle me-1"></i>Change Password
    </button>
  </div>
</ng-template>
